import logo from "../../images/logo/Sabadi.png";
import logoText from "../../images/logo/sabadiLogo.png";
// import ColorSchema from "../../../Components/kits/color.ts";
// import ColorSchema from "../../../Components/kits/color/index.ts";
import ColorSchema from "../color/index.ts";

const CloseIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={`${iconClassName}`}
        viewBox="0 0 25 25"
        style={{ width: "100%", height: "100%", ...style }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 7.5L17.3995 17.3995"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.60051 17.3995L17.5 7.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const ArrowRightIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={`${containerIconClassName}`} style={{ width, height }}>
      <svg
        className={`${iconClassName}`}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.9299 6.43005L20.9999 12.5001L14.9299 18.5701"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 12.5H20.83"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const UserIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={`${containerIconClassName}`} style={{ width, height }}>
      <svg
        className={`${iconClassName}`}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 12.5C15.2614 12.5 17.5 10.2614 17.5 7.5C17.5 4.73858 15.2614 2.5 12.5 2.5C9.73858 2.5 7.5 4.73858 7.5 7.5C7.5 10.2614 9.73858 12.5 12.5 12.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.0899 22.5C21.0899 18.63 17.2399 15.5 12.4999 15.5C7.75991 15.5 3.90991 18.63 3.90991 22.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const ArrowLeftIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5001 20.42L8.98009 13.9C8.21009 13.13 8.21009 11.87 8.98009 11.1L15.5001 4.57996"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const LocationIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.4999 13.9299C14.223 13.9299 15.6199 12.5331 15.6199 10.8099C15.6199 9.08681 14.223 7.68994 12.4999 7.68994C10.7768 7.68994 9.37988 9.08681 9.37988 10.8099C9.37988 12.5331 10.7768 13.9299 12.4999 13.9299Z"
          stroke={color}
          stroke-width="1.5"
        />
        <path
          d="M4.11995 8.99C6.08995 0.330002 18.92 0.340003 20.88 9C22.03 14.08 18.87 18.38 16.1 21.04C14.09 22.98 10.91 22.98 8.88995 21.04C6.12995 18.38 2.96995 14.07 4.11995 8.99Z"
          stroke={color}
          stroke-width="1.5"
        />
      </svg>
    </div>
  );
};

const PaymentListIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.05556 4.18193C7.07372 4.18193 6.07031 5.25755 6.07031 6.30952V20.2263L7.77446 19.9095C7.97392 19.8383 8.19048 19.8259 8.38568 19.9095L10.2778 20.7419L12.1699 19.9095C12.3818 19.8187 12.6182 19.8187 12.8301 19.9095L14.7222 20.7419L16.6143 19.9095C16.8095 19.8259 17.0261 19.8383 17.2255 19.9095L18.9299 20.2263V6.30952C18.9299 5.25755 17.9263 4.18193 16.9444 4.18193H8.05556ZM4.5 6.30952C4.5 4.20558 6.09188 2.5 8.05556 2.5H16.9444C18.9081 2.5 20.5 4.20558 20.5 6.30952V21.5476C20.5 21.8537 20.3626 22.1412 20.1309 22.3202C19.8991 22.4992 19.6011 22.5479 19.33 22.4511L16.9723 21.6091L15.0523 22.4319C14.8404 22.5227 14.604 22.5227 14.3921 22.4319L12.5 21.621L10.6079 22.4319C10.396 22.5227 10.1596 22.5227 9.94765 22.4319L8.02775 21.6091L5.66998 22.4511C5.39891 22.5479 5.10094 22.4992 4.86915 22.3202C4.63735 22.1412 4.5 21.8537 4.5 21.5476V6.30952ZM8.94444 9.16666C8.94444 8.64068 9.34241 8.32193 9.83333 8.32193H15.1667C15.6576 8.32193 16.0556 8.64068 16.0556 9.16666C16.0556 9.69265 15.6576 10.0086 15.1667 10.0086H9.83333C9.34241 10.0086 8.94444 9.69265 8.94444 9.16666ZM8.94444 14.8809C8.94444 14.355 9.34241 14.0391 9.83333 14.0391H15.1667C15.6576 14.0391 16.0556 14.355 16.0556 14.8809C16.0556 15.4069 15.6576 15.7257 15.1667 15.7257H9.83333C9.34241 15.7257 8.94444 15.4069 8.94444 14.8809Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

const HeadphoneIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.96005 18.99V16.07C5.96005 15.1 6.72005 14.23 7.80005 14.23C8.77005 14.23 9.64005 14.99 9.64005 16.07V18.88C9.64005 20.83 8.02005 22.4501 6.07005 22.4501C4.12005 22.4501 2.50005 20.82 2.50005 18.88V12.72C2.39005 7.10005 6.83005 2.55005 12.45 2.55005C18.07 2.55005 22.5 7.10005 22.5 12.61V18.7701C22.5 20.7201 20.88 22.34 18.93 22.34C16.98 22.34 15.36 20.7201 15.36 18.7701V15.96C15.36 14.99 16.12 14.12 17.2 14.12C18.17 14.12 19.04 14.88 19.04 15.96V18.99"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const LogoutIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.3999 8.05999C9.7099 4.45999 11.5599 2.98999 15.6099 2.98999H15.7399C20.2099 2.98999 21.9999 4.77999 21.9999 9.24999V15.77C21.9999 20.24 20.2099 22.03 15.7399 22.03H15.6099C11.5899 22.03 9.7399 20.58 9.4099 17.04"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.5001 12.5H4.12012"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.35 9.15002L3 12.5L6.35 15.85"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const ShoppingCartIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.5 2.5H4.24001C5.32001 2.5 6.17 3.43 6.08 4.5L5.25 14.46C5.11 16.09 6.39999 17.49 8.03999 17.49H18.69C20.13 17.49 21.39 16.31 21.5 14.88L22.04 7.38C22.16 5.72 20.9 4.37 19.23 4.37H6.32001"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.75 22.5C17.4404 22.5 18 21.9404 18 21.25C18 20.5596 17.4404 20 16.75 20C16.0596 20 15.5 20.5596 15.5 21.25C15.5 21.9404 16.0596 22.5 16.75 22.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.75 22.5C9.44036 22.5 10 21.9404 10 21.25C10 20.5596 9.44036 20 8.75 20C8.05964 20 7.5 20.5596 7.5 21.25C7.5 21.9404 8.05964 22.5 8.75 22.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.5 8.5H21.5"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const HomeIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.52 3.34004L4.13 7.54004C3.23 8.24004 2.5 9.73004 2.5 10.86V18.27C2.5 20.59 4.39 22.49 6.71 22.49H18.29C20.61 22.49 22.5 20.59 22.5 18.28V11C22.5 9.79004 21.69 8.24004 20.7 7.55004L14.52 3.22004C13.12 2.24004 10.87 2.29004 9.52 3.34004Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 18.49V15.49"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const AddIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 12.5H18.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 18.5V6.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const EditIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5 2.5H9.5C4.5 2.5 2.5 4.5 2.5 9.5V15.5C2.5 20.5 4.5 22.5 9.5 22.5H15.5C20.5 22.5 22.5 20.5 22.5 15.5V13.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5399 3.52001L8.65988 11.4C8.35988 11.7 8.05988 12.29 7.99988 12.72L7.56988 15.73C7.40988 16.82 8.17988 17.58 9.26988 17.43L12.2799 17C12.6999 16.94 13.2899 16.64 13.5999 16.34L21.4799 8.46001C22.8399 7.10001 23.4799 5.52001 21.4799 3.52001C19.4799 1.52001 17.8999 2.16001 16.5399 3.52001Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.4099 4.65002C16.0799 7.04002 17.9499 8.91002 20.3499 9.59002"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const SearchNormalIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 22L19 19"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const GPSIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 20C16.6421 20 20 16.6421 20 12.5C20 8.35786 16.6421 5 12.5 5C8.35786 5 5 8.35786 5 12.5C5 16.6421 8.35786 20 12.5 20Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 15.5C14.1569 15.5 15.5 14.1569 15.5 12.5C15.5 10.8431 14.1569 9.5 12.5 9.5C10.8431 9.5 9.5 10.8431 9.5 12.5C9.5 14.1569 10.8431 15.5 12.5 15.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 4.5V2.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.5 12.5H2.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 20.5V22.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.5 12.5H22.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const ArrowDownIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.4201 9.44995L13.9001 15.97C13.1301 16.74 11.8701 16.74 11.1001 15.97L4.58008 9.44995"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const DeliveryExpressIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        className={iconClassName}
        style={{ width: "100%", height: "100%", ...style }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.5 12.875C17.8787 12.875 17.375 13.3787 17.375 14C17.375 14.6213 17.8787 15.125 18.5 15.125C19.1213 15.125 19.625 14.6213 19.625 14C19.625 13.3787 19.1213 12.875 18.5 12.875Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.3469 22.4337C7.31633 23.6123 4.06732 21.6501 3.56639 18.5766L2.92372 18.7296L2 18.85V18V11C2 8.10886 3.35597 5.92292 5.35947 4.48451C7.34078 3.06203 9.94048 2.375 12.5 2.375C15.0595 2.375 17.6592 3.06204 19.6405 4.48452C21.644 5.92294 23 8.10887 23 11V14.9478C23 16.4944 22.0506 17.8823 20.6092 18.4428L10.3469 22.4337ZM13.136 9.50872L3.50001 10.9912C3.50271 8.63678 4.5836 6.8881 6.23428 5.70299C7.90922 4.50047 10.1845 3.875 12.5 3.875C14.8155 3.875 17.0908 4.50048 18.7657 5.703C20.4185 6.8896 21.5 8.64118 21.5 11V14.9478C21.5 15.8757 20.9303 16.7085 20.0655 17.0448L9.8032 21.0357C7.64385 21.8755 5.32639 20.4422 5.03146 18.2278L13.4237 16.2296L14 16C14 16 14 10.4688 14 10.25C14 10.0312 14 9.35 14 9.35L13.136 9.50872ZM12.5 14.9076L3.5 17.0505V12.5001C3.53762 12.5001 3.57572 12.4972 3.61404 12.4913L12.5 11.1242V14.9076Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

const SabadiIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
}> = ({
  width = 24,
  height = 24,
  style,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <img
        className={iconClassName}
        src={`${logo}`}
        style={{ width: "100%", height: "100%", ...style }}
        alt="logo"
      />
    </div>
  );
};

const SabadiTextIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
}> = ({
  width = 131,
  height = 64,
  style,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <img
        className={iconClassName}
        src={`${logoText}`}
        style={{ width: "100%", height: "100%", ...style }}
        alt="logo"
      />
    </div>
  );
};

const CheckIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 20,
  height = 20,
  style,
  color = "white",
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        width="10"
        height="8"
        className={`${iconClassName}`}
        style={{ width: "100%", height: "100%", ...style }}
        viewBox="0 0 10 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.26482 1.06912C8.95126 0.754628 8.46884 0.754628 8.15528 1.06912L3.26114 5.98269L1.34472 4.08232C1.03116 3.76783 0.548744 3.76783 0.235176 4.08232C-0.078392 4.39682 -0.078392 4.88066 0.235176 5.19515L2.70637 7.65194C2.85109 7.79709 3.06817 7.89386 3.26114 7.89386C3.4541 7.89386 3.67119 7.79709 3.81591 7.65194L9.26482 2.20615C9.57839 1.89165 9.57839 1.38362 9.26482 1.06912Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

const ShopIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 20,
  height = 20,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        width="21"
        height="17"
        viewBox="0 0 21 17"
        className={`${iconClassName}`}
        style={{ width: "100%", height: "100%", ...style }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.8203 12.7021C11.8794 12.7021 11.9372 12.7189 11.9864 12.7505C12.0355 12.782 12.0738 12.8268 12.0965 12.8793C12.1191 12.9317 12.125 12.9894 12.1135 13.0451C12.1019 13.1008 12.0735 13.1519 12.0317 13.1921C11.9899 13.2322 11.9366 13.2595 11.8786 13.2706C11.8206 13.2817 11.7605 13.276 11.7059 13.2543C11.6512 13.2326 11.6045 13.1958 11.5717 13.1486C11.5388 13.1014 11.5213 13.0459 11.5213 12.9891C11.5213 12.913 11.5528 12.84 11.6089 12.7862C11.6649 12.7324 11.741 12.7021 11.8203 12.7021V12.7021ZM3.77723 3.74585H0.587696V4.23787C0.58859 4.60473 0.740446 4.9564 1.01019 5.21627C1.27993 5.47615 1.64571 5.62318 2.02786 5.62534C2.4242 5.62534 3.09388 5.46954 3.35526 5.21697C3.48967 5.08773 3.59614 4.93426 3.66855 4.76539C3.74097 4.59652 3.7779 4.41557 3.77723 4.23295V3.74093V3.74585ZM0.734616 3.25384H3.86778L4.38029 0.477253H1.98856L0.734616 3.25056V3.25384ZM12.7155 0.473973L12.9324 3.25056H16.4363L15.8452 0.473973H12.7155ZM12.2474 3.25056L12.0321 0.473973H8.95703L8.74348 3.25056H12.2474ZM8.05842 3.25056L8.27026 0.473973H5.06706L4.55454 3.25056H8.05842ZM16.5268 0.473973L17.1162 3.25056H20.2408L18.8895 0.473973H16.5268ZM17.2102 3.75405V4.24607C17.2095 4.42869 17.2464 4.60964 17.3189 4.77851C17.3913 4.94738 17.4978 5.10085 17.6322 5.23009C17.8935 5.48266 18.5632 5.63846 18.9596 5.63846C19.3417 5.6363 19.7075 5.48927 19.9772 5.22939C20.247 4.96952 20.3988 4.61785 20.3997 4.25099V3.75897L17.2102 3.75405ZM12.9837 3.74585V4.23787C12.9829 4.42064 13.02 4.60174 13.0927 4.77066C13.1655 4.93957 13.2724 5.09295 13.4073 5.22189C13.6687 5.47446 14.3367 5.63026 14.733 5.63026C15.1294 5.63026 15.7974 5.47446 16.0587 5.22189C16.1937 5.09295 16.3006 4.93957 16.3733 4.77066C16.4461 4.60174 16.4832 4.42064 16.4824 4.23787V3.74585H12.9837ZM8.74348 3.74585V4.23787C8.74275 4.42064 8.77982 4.60174 8.85255 4.77066C8.92528 4.93957 9.03221 5.09295 9.16716 5.22189C9.42854 5.47446 10.0965 5.63026 10.4929 5.63026C10.8892 5.63026 11.5572 5.47446 11.8186 5.22189C11.9535 5.09295 12.0604 4.93957 12.1332 4.77066C12.2059 4.60174 12.243 4.42064 12.2422 4.23787V3.74585H8.74348ZM4.50329 3.74585V4.23787C4.50256 4.42064 4.53964 4.60174 4.61236 4.77066C4.68509 4.93957 4.79203 5.09295 4.92697 5.22189C5.18835 5.47446 5.85632 5.63026 6.25267 5.63026C6.64901 5.63026 7.31699 5.47446 7.57837 5.22189C7.71331 5.09295 7.82024 4.93957 7.89297 4.77066C7.9657 4.60174 8.00277 4.42064 8.00204 4.23787V3.74585H4.50329ZM18.1208 6.00747C17.9072 5.91235 17.381 5.78114 17.2153 5.62206C17.0707 5.48287 16.9486 5.32365 16.8531 5.14973C16.7577 5.32365 16.6356 5.48287 16.491 5.62206C16.1254 5.97303 15.2951 6.18951 14.733 6.18951C14.171 6.18951 13.3441 5.97303 12.9837 5.62206C12.839 5.48287 12.717 5.32365 12.6215 5.14973C12.526 5.32365 12.4039 5.48287 12.2593 5.62206C11.8937 5.97303 11.0635 6.18951 10.5014 6.18951C9.93934 6.18951 9.10907 5.97303 8.74348 5.62206C8.59522 5.48356 8.46966 5.32431 8.37105 5.14973C8.27558 5.32365 8.1535 5.48287 8.00888 5.62206C7.64329 5.97303 6.81302 6.18951 6.25096 6.18951C5.6889 6.18951 4.85863 5.97303 4.49304 5.62206C4.34842 5.48287 4.22634 5.32365 4.13087 5.14973C4.03539 5.32365 3.91331 5.48287 3.76869 5.62206C3.52781 5.85331 2.894 6.02551 2.55916 6.11407C2.48627 6.12282 2.4111 6.12938 2.33366 6.13375V15.7214C2.33383 15.7701 2.35411 15.8167 2.39003 15.851C2.42665 15.8864 2.47641 15.9065 2.52841 15.9068H10.2161V9.28591C10.217 8.86252 10.3926 8.45672 10.7045 8.15734C11.0163 7.85795 11.439 7.68938 11.8801 7.68851H14.6305C15.0713 7.68981 15.4935 7.85858 15.805 8.15791C16.1165 8.45725 16.2919 8.8628 16.2928 9.28591V15.9084H18.459C18.4845 15.9082 18.5097 15.9032 18.5332 15.8936C18.5566 15.8841 18.5779 15.8701 18.5957 15.8526V15.8526C18.6308 15.818 18.6504 15.7715 18.6503 15.7231V6.14687C18.6503 6.12883 18.6503 6.11079 18.6503 6.09439C18.4715 6.07635 18.294 6.04732 18.119 6.00747H18.1208ZM10.99 15.9084H15.5206V9.28591C15.5197 9.05912 15.4255 8.84187 15.2584 8.68151C15.0914 8.52115 14.8651 8.43067 14.6288 8.42981H11.8818C11.6455 8.43067 11.4192 8.52115 11.2522 8.68151C11.0851 8.84187 10.9909 9.05912 10.99 9.28591V15.9084ZM5.12514 8.9087H7.87562C7.97818 8.9087 8.07656 8.9477 8.14924 9.01716C8.22192 9.08663 8.26297 9.1809 8.26343 9.27935V13.204C8.26343 13.3027 8.22257 13.3974 8.14984 13.4672C8.07711 13.537 7.97848 13.5763 7.87562 13.5763H5.12514C5.02229 13.5763 4.92365 13.537 4.85092 13.4672C4.7782 13.3974 4.73734 13.3027 4.73734 13.204V9.27935C4.73779 9.1809 4.77885 9.08663 4.85153 9.01716C4.9242 8.9477 5.02258 8.9087 5.12514 8.9087V8.9087ZM7.48953 9.65164H5.50952V12.8333H7.48953V9.65164ZM1.42992 6.06815C1.11483 5.99742 0.825555 5.8461 0.592821 5.63026C0.404031 5.45001 0.254412 5.23555 0.152649 4.99935C0.0508854 4.76314 -0.00099635 4.50988 1.44914e-05 4.25427V3.49329C0.000326617 3.45495 0.0102905 3.41725 0.0290569 3.3834L1.61443 0.113164C1.63408 0.0787993 1.66301 0.0501534 1.69819 0.0302396C1.73336 0.0103258 1.77347 -0.000119993 1.81431 1.03994e-06H19.0518C19.095 0.000131517 19.1372 0.0118816 19.1738 0.0339156C19.2103 0.0559495 19.2397 0.0873835 19.2585 0.124644L20.9669 3.37684C20.9864 3.40819 20.9976 3.44368 20.9994 3.48017V3.48017C21.0002 3.48725 21.0002 3.4944 20.9994 3.50149V4.25263C20.9992 4.50686 20.9468 4.75857 20.8451 4.99329C20.7434 5.22802 20.5943 5.44114 20.4066 5.62042C20.1754 5.83816 19.8844 5.98832 19.5677 6.05339C19.5746 6.08356 19.5781 6.11435 19.578 6.14523V15.7214C19.5767 16.0037 19.4587 16.2738 19.25 16.4726C19.1469 16.5719 19.0245 16.6507 18.8896 16.7044C18.7547 16.7582 18.6102 16.7859 18.4641 16.7858H2.53354C2.3878 16.7856 2.24353 16.7579 2.10898 16.7041C1.97443 16.6504 1.85224 16.5717 1.74939 16.4726V16.4726C1.64611 16.3742 1.56411 16.2572 1.50812 16.1283C1.45212 15.9994 1.42322 15.8611 1.42309 15.7214V6.14687C1.42048 6.11795 1.42048 6.08887 1.42309 6.05995L1.42992 6.06815Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

const ShareIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 20,
  height = 20,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        className={`${iconClassName}`}
        style={{ width: "100%", height: "100%", ...style }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.5 8.5C20.1569 8.5 21.5 7.15685 21.5 5.5C21.5 3.84315 20.1569 2.5 18.5 2.5C16.8431 2.5 15.5 3.84315 15.5 5.5C15.5 7.15685 16.8431 8.5 18.5 8.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.5 15.5C8.15685 15.5 9.5 14.1569 9.5 12.5C9.5 10.8431 8.15685 9.5 6.5 9.5C4.84315 9.5 3.5 10.8431 3.5 12.5C3.5 14.1569 4.84315 15.5 6.5 15.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5 22.5C20.1569 22.5 21.5 21.1569 21.5 19.5C21.5 17.8431 20.1569 16.5 18.5 16.5C16.8431 16.5 15.5 17.8431 15.5 19.5C15.5 21.1569 16.8431 22.5 18.5 22.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.09009 14.01L15.9201 17.99"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.9101 7.01001L9.09009 10.99"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const TrashIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 20,
  height = 20,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        className={`${iconClassName}`}
        style={{ width: "100%", height: "100%", ...style }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.375 7.23254C17.4613 6.94379 14.53 6.79504 11.6075 6.79504C9.875 6.79504 8.1425 6.88254 6.41 7.05754L4.625 7.23254"
          stroke={color}
          stroke-width="1.3125"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.4375 6.34875L9.63 5.2025C9.77 4.37125 9.875 3.75 11.3537 3.75H13.6463C15.125 3.75 15.2387 4.40625 15.37 5.21125L15.5625 6.34875"
          stroke={color}
          stroke-width="1.3125"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.4936 9.99744L17.9249 18.8087C17.8286 20.1824 17.7499 21.2499 15.3086 21.2499H9.6911C7.24985 21.2499 7.1711 20.1824 7.07485 18.8087L6.5061 9.99744"
          stroke={color}
          stroke-width="1.3125"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0388 16.4375H13.9526"
          stroke={color}
          stroke-width="1.3125"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.3125 12.9375H14.6875"
          stroke={color}
          stroke-width="1.3125"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const SortIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 20,
  height = 20,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        className={`${iconClassName}`}
        style={{ width: "100%", height: "100%", ...style }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.6">
          <path
            d="M8.5 6.5H21.5"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.5 12.5H21.5"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.5 18.5H21.5"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.5 6.5H3.51"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.5 12.5H3.51"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.5 18.5H3.51"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </div>
  );
};

const MinesIcon: React.FC<{
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
}> = ({
  width = 20,
  height = 20,
  style,
  color = `${ColorSchema.foreground_surface_me}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height }}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        className={`${iconClassName}`}
        style={{ width: "100%", height: "100%", ...style }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 12.5H19.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export {
  CloseIcon,
  ArrowRightIcon,
  UserIcon,
  ArrowLeftIcon,
  LocationIcon,
  PaymentListIcon,
  HeadphoneIcon,
  LogoutIcon,
  ShoppingCartIcon,
  HomeIcon,
  AddIcon,
  EditIcon,
  SearchNormalIcon,
  GPSIcon,
  ArrowDownIcon,
  DeliveryExpressIcon,
  SabadiIcon,
  CheckIcon,
  SabadiTextIcon,
  ShopIcon,
  ShareIcon,
  TrashIcon,
  SortIcon,
  MinesIcon,
};
